export { default } from './P5TextImageGallery';
